$(function () {
  const KEY_CODE_NUMPAD_0 = 96;
  const KEY_CODE_NUMPAD_9 = 105;
  const KEY_CODE_DIGIT_0 = 48;
  const KEY_CODE_DIGIT_9 = 57;
  const KEY_CODE_LETTER_A = 65;
  const KEY_CODE_LETTER_Z = 90;
  const KEY_CODE_BACKSPACE = 8;
  const KEY_CODE_DELETE = 46;
  const NUMPAD_KEY_CODE_OFFSET = KEY_CODE_NUMPAD_0;
  const DIGIT_KEY_CODE_OFFSET = KEY_CODE_DIGIT_0;

  Inputmask.extendDefaults({
    onBeforePaste: function (pastedValue) {
      const $el = $(this)[0]?.$el || null;
      if (!$el) {
        throw new Error('Elemento não encontrado no contexto atual.');
      }

      return $el.hasClass('no-paste') ? '' : pastedValue;
    }
  });

  Inputmask.extendAliases({
    cpf: {
      mask: '999.999.999-99',
      clearIncomplete: true,
      placeholder: '_',
    },
    cnpj: {
      mask: 'SS.SSS.SSS/SSSS-99',
      clearIncomplete: true,
      placeholder: '_',
      definitions: {
        'S': { validator: '[0-9A-Za-z]', casing: 'upper' }
      }
    },
  });

  const originalInputmask = $.fn.inputmask;

  /**
   * @var Object<string, function($input: JQuery): void> customMaskHandlers
   */
  const customMaskHandlers = {
    cpf_cnpj: ($input) => createCpfCnpjMaskHandler($input).init(),
  };

  function createCpfCnpjMaskHandler($input) {
    const CPF_MASK_NAME = 'cpf';
    const CNPJ_MASK_NAME = 'cnpj';

    function getCurrentMask() {
      return $input[0]?.inputmask?.opts?.alias || CPF_MASK_NAME;
    }

    function setValue(value) {
      $input.inputmask('setvalue', value);
    }

    // prevenir onBeforeMask chamar applyMask recursivamente
    let isSwitchingMask = false;
    function applyMask(maskName, rawValue) {
      $input.inputmask(maskName, {
        // prevenir de ouvir keydown que pode vir `undefined` do autofill
        inputEventOnly: true,

        // recebe o valor limpo antes do inputmask tratar o campo
        onBeforeMask: function (value) {
          // não tratar máscara se estiver mudando de máscara
          if (isSwitchingMask) return value;

          const raw = normalizeRawValue(value);
          const correctMask = resolveMask(raw);

          if (correctMask !== maskName) {
            // se o valor não for compatível com a máscara, mudar para outra
            isSwitchingMask = true;
            setTimeout(() => {
              applyMask(correctMask, raw);
              isSwitchingMask = false;
            }, 0);

            // string vazia para não deixar inputmask usar máscara errada
            return '';
          }

          return value;
        }
      });

      if (rawValue !== undefined) {
        // inputmask pode duplicar o ultimo caractere ao trocar a máscara, com setTimeout o valor atualiza corretamente.
        setTimeout(() => setValue(rawValue), 0)
      }
    }

    function resolveMask(value) {
      return /[A-Z]/.test(value.toUpperCase()) || value.length > 11 ? CNPJ_MASK_NAME : CPF_MASK_NAME;
    }

    function isAlphaNumericKey(key) {
      return /^[A-Za-z0-9]$/.test(key);
    }

    function normalizeRawValue(value) {
      return String(value || '')
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '');
    }

    function getDisplayedRawValue() {
      return normalizeRawValue($input.val() || '');
    }

    function normalizeKey(event) {
      const key = String(event?.key || '').toUpperCase();
      if (key) {
        return key;
      }

      const keyCode = Number(event?.keyCode || event?.which || 0);

      // Teclas do teclado numerico: Numpad0 ... Numpad9.
      // Ex.: 96 -> 0, 104 -> 8, 105 -> 9.
      if (keyCode >= KEY_CODE_NUMPAD_0 && keyCode <= KEY_CODE_NUMPAD_9) {
        return String(keyCode - NUMPAD_KEY_CODE_OFFSET);
      }

      // Linha superior do teclado: Digit0 ... Digit9.
      // Ex.: 48 -> 0, 56 -> 8, 57 -> 9.
      if (keyCode >= KEY_CODE_DIGIT_0 && keyCode <= KEY_CODE_DIGIT_9) {
        return String(keyCode - DIGIT_KEY_CODE_OFFSET);
      }

      // Letras A...Z da tabela ASCII.
      if (keyCode >= KEY_CODE_LETTER_A && keyCode <= KEY_CODE_LETTER_Z) {
        return String.fromCharCode(keyCode);
      }

      if (keyCode === KEY_CODE_BACKSPACE) {
        return 'BACKSPACE';
      }

      if (keyCode === KEY_CODE_DELETE) {
        return 'DELETE';
      }

      return '';
    }

    /** @param {ClipboardEvent} event */
    function handlePaste(event) {
      if (event.currentTarget.classList.contains('no-paste')) {
        setValue('')
        return;
      }

      const pastedValue = String(
        event.originalEvent?.clipboardData?.getData('text') ||
        window.clipboardData?.getData('Text') ||
        ''
      );

      if (!pastedValue) {
        return;
      }

      const normalizedValue = normalizeRawValue(pastedValue);
      const nextMask = resolveMask(normalizedValue);

      event.preventDefault();
      applyMask(nextMask, normalizedValue);
    }

    /** @param {InputEvent} event */
    function handleBeforeInput(event) {
      const inputType = event.originalEvent?.inputType;
      const data = String(event.originalEvent?.data || '').trim().toUpperCase();

      if (inputType === 'insertFromPaste' || inputType === 'insertFromDrop') {
        const nextMask = resolveMask(data);
        if (getCurrentMask() !== nextMask) {
          event.preventDefault();
          applyMask(nextMask, data);
        }

        return;
      }

      if (inputType !== 'insertText' || !data) {
        return;
      }

      const currentValue = getDisplayedRawValue();
      const nextValue = currentValue + data;
      const nextMask = resolveMask(nextValue);
      const currentMask = getCurrentMask();

      if (currentMask !== nextMask) {
        event.preventDefault();
        applyMask(nextMask, nextValue);
      }
    }

    /** @param {KeyboardEvent} event */
    function handleKeyDown(event) {
      if (event?.ctrlKey || event?.metaKey || event?.altKey) {
        return;
      }

      const key = normalizeKey(event);
      // ignora eventos de composição IME (acentos, caracteres asiáticos, etc)
      if (event?.isComposing || key === 'PROCESS') {
        return;
      }

      const currentValue = getDisplayedRawValue();
      const currentMask = getCurrentMask();

      if (!isAlphaNumericKey(key)) {
        return;
      }

      if (currentMask !== CPF_MASK_NAME) {
        return;
      }

      const isLetter = /[A-Z]/.test(key);
      if (!isLetter) {
        // Para dígitos, o beforeinput e o input ajustam a mascara quando necessário.
        return;
      }

      event.preventDefault();
      applyMask(CNPJ_MASK_NAME, currentValue + key);
    }

    /** @param {InputEvent} _ */
    function handleInput(_) {
      const raw = getDisplayedRawValue();
      const currentMask = getCurrentMask();
      const nextMask = resolveMask(raw);

      if (currentMask !== nextMask) {
        applyMask(nextMask, raw);
      }
    }

    return {
      init: function () {
        applyMask(resolveMask(normalizeRawValue($input.val()))); // Máscara inicial

        const CPF_CNPJ_EVENT_NAMESPACE = '.cpfCnpjMask';
        /** Usar eventos com namespace para poder remover os listeners anteriores (somente desse contexto) caso use `.inputmask` novamente */
        $input.off(CPF_CNPJ_EVENT_NAMESPACE);
        $input.on('beforeinput' + CPF_CNPJ_EVENT_NAMESPACE, handleBeforeInput);
        $input.on('keydown' + CPF_CNPJ_EVENT_NAMESPACE, handleKeyDown);
        $input.on('input' + CPF_CNPJ_EVENT_NAMESPACE, handleInput);
        $input.on('paste' + CPF_CNPJ_EVENT_NAMESPACE, handlePaste);
        $input.on('drop' + CPF_CNPJ_EVENT_NAMESPACE, handlePaste);
      }
    };
  }

  /**
   * Sobrescreve o método `inputmask` para aplicar máscaras customizadas definidas em `customMaskHandlers`,
   * para suportar utilização via `.inputmask('cpf_cnpj')` ou via atributo `data-mask="cpf_cnpj"`.
   */
  $.fn.inputmask = function (aliasOrOptions) {
    const customMaskHandler = typeof aliasOrOptions === 'string'
      ? customMaskHandlers[aliasOrOptions]
      : null;

    if (!customMaskHandler) {
      return originalInputmask.apply(this, arguments);
    }

    this.each(function () {
      customMaskHandler($(this));
    });

    return this;
  };

  /**
   * Aplica máscaras customizadas para os campos que possuem o atributo `data-mask` definido.
   * Exemplo:
   * ```html
   * <input type="text" data-mask="cpf_cnpj" />
   * ```
   */
  $('input[data-mask]').each(function () {
    const $input = $(this);
    const maskName = $input.data('mask');

    $input.inputmask(maskName);
  });
});
